function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371000; // Earth radius in meters
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lng2 - lng1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in meters
}

function findApplicableZone(userLocation, zones) {
  const filteredZones = zones.filter((zone) => zone.visible);
  // Sort zones by area (ascending) to prioritize smaller zones when overlapping
  const sortedZones = [...filteredZones].sort((a, b) => a.area - b.area);

  for (const zone of sortedZones) {
    if (!zone.visible) continue;

    if (zone.type === "circle") {
      const distance = calculateDistance(
        userLocation.lat,
        userLocation.lng,
        zone.center.lat,
        zone.center.lng
      );

      if (distance <= zone.radius) {
        return zone;
      }
    }
    // Additional shape types (polygon, etc.) could be handled here
  }

  return false; // No applicable zone found
}

export function calculateDeliveryZoneDetails(userLocation, zones) {
  const applicableZone = findApplicableZone(userLocation, zones);
  if (!applicableZone) {
    // return {
    //   status: "out_of_range",
    //   message: "Sorry, your location is outside our delivery zones.",
    // };
    return applicableZone;
  }

  return applicableZone;

  // return {
  //   status: "in_range",
  //   zone: applicableZone.name,
  //   delivery_fee: parseFloat(applicableZone.delivery_fee),
  //   minimum_order_amount: parseFloat(applicableZone.minimum_order_amount),
  // };
}
